'use client';

import { ReactNode, useState } from 'react';
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

const QueryProvider = ({ children }: { children: ReactNode }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error) => {
            console.error('[QueryCache]', error);
          },
        }),
        mutationCache: new MutationCache({
          onError: async (error) => {
            // Log all mutation errors to SystemLog (visible in admin/logs).
            // Individual components still handle their own toast UI.
            const { loggedToast } = await import('@/lib/logged-toast');
            loggedToast.logError(
              error.message || 'Mutation failed',
            );
          },
        }),
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export { QueryProvider };
